<template>
  <transition name="search-bar">
    <div :class="classModifiers" v-if="show">
      <div class="search-bar__inner">
        <form @submit.prevent="onSubmit">
          <label class="search-bar__control" for="search-query">
            <input
              :class="inputClassModifiers"
              @focus="handleFocus"
              @blur="handleBlur"
              ref="searchInput"
              v-model="searchQuery"
              id="search-query"
              type="text"
              placeholder="SEARCH MARKETS..."
            />
            <button class="search-bar__submit" type="submit"></button>
          </label>
        </form>
        <div class="search-bar__close" @click="onClose">
          <div class="search-bar__close-icon"></div>
          <div class="search-bar__close-text">Close</div>
        </div>
      </div>
      <div :class="summaryClassModifiers" v-if="false">
        <div class="row" v-if="searchTotal > 0">
          <div class="column small-6 text-left">
            <strong>Search Results</strong>: {{ searchFor }}
          </div>
          <div class="column small-6 text-right">
            {{ searchTotal }} Market<span v-if="searchTotal !== 1">s</span>
          </div>
        </div>
        <div class="row" v-if="searchTotal === 0">
          <div class="column small-8 text-left">
            <strong>No Search Results</strong>: {{ searchFor }}
          </div>
          <div class="column small-4 text-right">0 Markets</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script src="./search-bar.js"></script>
<style src="./search-bar.scss" lang="scss"></style>
